import get from 'lodash/get';
import { useQuery } from '@apollo/client/react';
import { NotificationsDocument, type NotificationsQuery } from 'graphql/generated/graphql';

const useGetNotifications = (): [NotificationsQuery['notifications'], boolean] => {
  const { data, loading } = useQuery(NotificationsDocument);

  const noNotifications: NotificationsQuery['notifications'] = [];
  const notifications = get(data, 'notifications', noNotifications);

  return [notifications, loading];
};

export default useGetNotifications;
